import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { employeesAccessRoles } from './access';

export const employeesRoutes: RouteObject[] = [
  {
    path: 'employees',
    async lazy() {
      const { EmployeesPage } = await import('./pages/EmployeesPage');
      return { Component: EmployeesPage };
    },
    handle: defineHandle({
      roles: [...employeesAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.employees',
    }),
  },
  {
    path: 'employees/:authId',
    async lazy() {
      const { EmployeeDetailPage } = await import('./pages/EmployeeDetailPage');
      return { Component: EmployeeDetailPage };
    },
    handle: defineHandle({
      roles: [...employeesAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.employees',
    }),
  },
];
